import { useContext } from 'react';
import { CoreContext } from '../context/index.js';

const getStructuredData = () => {
    const { data: { siteConfig: { siteName, csrEmail, siteUrl, companyTelephone }, }, } = useContext(CoreContext);
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: siteUrl,
        name: siteName,
        telephone: companyTelephone,
        email: csrEmail,
    };
};

export { getStructuredData };
//# sourceMappingURL=schema.js.map
